import React, { ReactNode } from 'react';
import { GoTriangleUp } from "react-icons/go";

interface ChartHeaderProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  percentage?: string;
  percentageContent?: string;
}

const ChartHeader: React.FC<ChartHeaderProps> = ({ title, subtitle, children, percentage, percentageContent }) => {
  return (
    <div>
      <div className="h-heading-con">
        <div>
          <h3 className="chart-heading">{title}</h3>
          {subtitle && <p className="chart-para text-base">{subtitle}</p>}
        </div>
        {children && <div>{children}</div>}
        {percentage && (
          <div>
            <div className="flex items-center gap-2">
              <div><h3 className="chart-heading">{percentage}</h3></div>
              <GoTriangleUp className="text-green100" />
            </div>
            <p className="chart-para text-base">{percentageContent}</p>
          </div>
        )}
      </div>
      <hr className="mb-6 mt-1" />
    </div>
  );
};

export default ChartHeader;
